import React from 'react';
import { useHistory } from 'react-router';

// Styles
import PatternButton from 'js/components/TriiboComponents/Buttons/PatternButton';
import { Grid, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import { StandardSelect } from 'js/components/TriiboComponents/Select/StandardSelect';

export const ButtonsHeaderContent = ({
  filterType,
  priorities,
  setFilterType,
  status,
  setStatus,
}) => {
  const history = useHistory();
  const isMdUp = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const typeOptions = [
    { id: 'popup', name: 'Pop-up' },
    { id: 'tarja', name: 'Tarja' },
  ];

  const handleButtonCreate = () => {
    history.push({
      pathname: `${history.location.pathname}/criar`,
      state: {
        priorities,
      },
    });
  };

  const handleSelectStatus = () => {
    setStatus(!status);
  };

  return (
    <Grid
      container
      alignItems="center"
      justifyContent={isMdUp ? 'space-between' : 'center'}
      spacing={2}
    >
      <Grid item md={4} xs={12}>
        <ToggleButtonGroup color="primary" value={status} exclusive onChange={handleSelectStatus}>
          <ToggleButton value={true} sx={{ fontWeight: '600' }}>
            Ativo/Em espera
          </ToggleButton>
          <ToggleButton value={false} sx={{ fontWeight: '600' }}>
            Expirado
          </ToggleButton>
        </ToggleButtonGroup>
      </Grid>

      <Grid
        item
        md={8}
        xs={12}
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        gap={2}
      >
        <StandardSelect
          label="Tipo"
          menuOptions={typeOptions}
          id="id"
          displayProp="name"
          setValue={setFilterType}
          value={filterType}
          width={isMdUp ? '25%' : '100%'}
        />
        <PatternButton height={'3.3rem'} width={'40%'} onClick={handleButtonCreate}>
          Criar alerta
        </PatternButton>
      </Grid>
    </Grid>
  );
};
